import React from 'react';

import UsedMediaCard from '../used-media-card/UsedMediaCard';
import { getStoryMediaId } from '../../../../media/storyMediaItem';

import scss from './UsedMediaList.module.scss';

function UsedMediaList({ items, selectedIds, onSelect, onPreview }) {
  return (
    <div className={scss.wrapper}>
      {items.map((media) => (
        <UsedMediaCard
          key={media.sourceId}
          media={media}
          isSelected={selectedIds.has(getStoryMediaId(media))}
          onSelect={onSelect}
          onPreview={onPreview}
        />
      ))}
    </div>
  );
}

export default UsedMediaList;
